import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/dashboard';
import Dashboard from './Dashboard';


const ms2p = (state) => {
    return {
        ...state.dashboard,
        me: state.login.me
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Dashboard);
